import type { AdvantageWhatsappCta } from '@presentation/components';
import type { MouseEventHandler } from 'react';

type PartnerName = 'progenus';

export interface Advantage {
  name: PartnerName;
  text: string;
  moreInfo?: string;
  whatsappCta: AdvantageWhatsappCta;
  cta: string;
  logo: string | undefined;
  QRCode: string | undefined;
  onClick(): MouseEventHandler;
}

export interface MtAdvantagesPageControllerData {
  resource: 'breeder' | 'buyer';
}

export interface MtAdvantagesPageControllerProps extends MtAdvantagesPageControllerData {}
